<template>
  <main>
    <div class="courses-page">
      <div class="section-frame">
        <ul class="breadcrumbs">
          <li>
            <router-link to="/"><i class="fa-home-line"></i></router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link to="/news">
              <div>{{ $t("all_news") }}</div>
            </router-link>
          </li>
          <li><i class="fa-arrow-next"></i></li>
          <li>
            <router-link v-if="news" :to="`/news/${news.slug}`">{{
              news.title
            }}</router-link>
          </li>
        </ul>
      </div>
      <div class="courses-main-info">
        <div class="section-frame">
          <div class="courses-main-content">
            <div class="page-sub-title sub-title-white">
              <div class="courses-title-star">
                <h1>
                  <i class="fa-title"></i>
                  {{
                    news && news.title
                      ? news.title
                      : ".............................."
                  }}
                </h1>
              </div>
              <p class="courses-main-data" style="margin-left: auto">
                <i class="fa-clock"></i
                ><span v-cyr2lat="$store.getters.lang">{{
                  $t("last_news_update")
                }}</span>
                <span>{{
                  news && news.date_created
                    ? news.date_created
                    : "....................."
                }}</span>
              </p>
            </div>
            <div class="courses-data-frame courses-single-data-frame">
              <div class="courses-share">
                <p>
                  <span>{{ $t("share") }}</span>
                </p>
                <ul>
                  <li>
                    <a href="#"><i class="fa-facebook"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="fa-telegram"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="fa-instagram"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="fa-vk"></i></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="courses-content">
        <div class="section-frame">
          <div class="courses-single-frame">
            <div class="courses-single-content">
              <div
                class="courses-single-lesen-info"
                v-html="
                  news && news.content
                    ? $processHtml(news.content)
                    : '..........................................'
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  title: "Yangilik",
  computed: {
    news() {
      return this.$store.getters.getNews;
    },
  },
  async mounted() {
    await this.$store.dispatch("getNewsBySlug", this.$route.params.slug);
  },
};
</script>
